import { GET, POST, PATCH, DELETE } from "../config";

/**
 * Endpoints para gestión de servicios.
 * Base URL: /api/services/
 */

// ==================== SERVICIOS ====================

/**
 * Listar servicios
 * @param {number} page - Número de página
 * @param {object} filters - Filtros (branch, category, service_type, is_active, search)
 * @returns {Promise} Lista de servicios
 */
export const list = async (page = 1, filters = {}) => {
  let url = `services/services/?page=${page}`;
  url += `&page_size=50`;

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.category) {
    url += `&category=${filters.category}`;
  }

  if (filters.service_type) {
    url += `&service_type=${filters.service_type}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  if (filters.search) {
    url += `&name__icontains=${filters.search}`;
  }

  const response = await GET(url);
  return response;
};

/**
 * Obtener un servicio por ID
 * @param {string} id - UUID del servicio
 * @returns {Promise} Datos del servicio
 */
export const retrieve = async (id) => {
  const response = await GET(`services/services/${id}/`);
  return response;
};

/**
 * Crear un nuevo servicio
 * @param {object} data - Datos del servicio
 * @returns {Promise} Servicio creado
 */
export const create = async (data) => {
  const response = await POST("services/services/", data);
  return response;
};

/**
 * Actualizar un servicio
 * @param {string} id - UUID del servicio
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Servicio actualizado
 */
export const update = async (id, data) => {
  const response = await PATCH(`services/services/${id}/`, data);
  return response;
};

/**
 * Eliminar un servicio
 * @param {string} id - UUID del servicio
 * @returns {Promise} Respuesta de eliminación
 */
export const destroy = async (id) => {
  const response = await DELETE(`services/services/${id}/`);
  return response;
};

/**
 * Obtener resumen de servicios
 * @returns {Promise} Resumen de servicios
 */
export const getSummary = async () => {
  const response = await GET("services/services/summary/");
  return response;
};

/**
 * Obtener servicios por categoría
 * @param {string} categoryType - Tipo de categoría (MEMBERSHIP, SUBSCRIPTION, etc.)
 * @returns {Promise} Lista de servicios filtrados por categoría
 */
export const getByCategory = async (categoryType) => {
  const response = await GET(
    `services/services/by_category/?category_type=${categoryType}`
  );
  return response;
};

// ==================== CATEGORÍAS DE SERVICIOS ====================

/**
 * Listar categorías de servicios
 * @param {number} page - Número de página
 * @param {object} filters - Filtros (branch, category_type, is_active, search)
 * @returns {Promise} Lista de categorías
 */
export const listCategories = async (page = 1, filters = {}) => {
  let url = `services/service-categories/?page=${page}`;
  url += `&page_size=50`;

  if (filters.branch) {
    url += `&branch=${filters.branch}`;
  }

  if (filters.category_type) {
    url += `&category_type=${filters.category_type}`;
  }

  if (filters.is_active !== undefined) {
    url += `&is_active=${filters.is_active}`;
  }

  if (filters.search) {
    url += `&name__icontains=${filters.search}`;
  }

  const response = await GET(url);
  return response;
};

/**
 * Obtener una categoría por ID
 * @param {string} id - UUID de la categoría
 * @returns {Promise} Datos de la categoría
 */
export const retrieveCategory = async (id) => {
  const response = await GET(`services/service-categories/${id}/`);
  return response;
};

/**
 * Crear una nueva categoría
 * @param {object} data - Datos de la categoría
 * @returns {Promise} Categoría creada
 */
export const createCategory = async (data) => {
  const response = await POST("services/service-categories/", data);
  return response;
};

/**
 * Actualizar una categoría
 * @param {string} id - UUID de la categoría
 * @param {object} data - Datos a actualizar
 * @returns {Promise} Categoría actualizada
 */
export const updateCategory = async (id, data) => {
  const response = await PATCH(`services/service-categories/${id}/`, data);
  return response;
};

/**
 * Eliminar una categoría
 * @param {string} id - UUID de la categoría
 * @returns {Promise} Respuesta de eliminación
 */
export const destroyCategory = async (id) => {
  const response = await DELETE(`services/service-categories/${id}/`);
  return response;
};

